import { createContext, useContext, useMemo, useRef } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getContactUs , updateContactUs } from "../../api/home";

import { generatePayload, getIntialValues } from "./helper";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const trainersArrayRef = useRef();
  const believesArrayRef = useRef();
  const toaster = useToaster();
  const toolsArrayRef = useRef();
  const scaleArrayRef = useRef();

  const getContactUsQuery = useQuery({
    queryKey: [""],
    queryFn: getContactUs,
  });

  const updateContactUsQuery = useMutation({ mutationFn: updateContactUs });

  const initialValues = useMemo(() => {
    const homeData = getContactUsQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getContactUsQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getContactUsQuery?.data?.data?.data?.[0] || {};

    updateContactUsQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getContactUsQuery.refetch();
        },
      },
    );
    return;
  };

  const handleTrainerAdd = () => {
    trainersArrayRef.current?.push({
      label: "",
      count: "",
      image_link: "",
    });
  };
  const handleTrainerDelete = (index) => () => {
    trainersArrayRef.current?.remove(index);
  };

  const handleBeliefAdd = () => {
    believesArrayRef.current?.push({
      image_link: "",
      label: "",
      description: "",
    });
  };

  const handleBeliefDelete = (index) => () => {
    believesArrayRef.current?.remove(index);
  };

  const handleScaleAdd = () => {
    scaleArrayRef.current?.push({
      title: "",
      description: "",
      details: "",
      icon: "",
      desktop_image_url: "",
    });
  };

  const handleScaleDelete = (index) => () => {
    scaleArrayRef.current?.remove(index);
  };


   const handleToolAdd = () => {
    toolsArrayRef.current?.push({ image_url: "" });
  };

  const handleToolDelete = (index) => () => {
    toolsArrayRef.current?.remove(index);
  };

  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,

        handleTrainerAdd,
        handleTrainerDelete,
        trainersArrayRef,
        believesArrayRef,
        handleBeliefAdd,
        handleBeliefDelete,
        scaleArrayRef,
        handleScaleAdd,
        handleScaleDelete,
        toolsArrayRef,
        handleToolAdd,
        handleToolDelete,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
